<template>
    <div class="contentno">
        <img src="../../assets/question_icon_01.png"/>
        <span class="content-span">{{content}}，敬请期待</span>
        <slot name="result"></slot>
    </div>
</template>
<script>
export default {
    name: 'ContentNo',
    props: {
        content: {
            type: String,
            value: ''
        }
    }
}
</script>
<style scoped>
.contentno{display: flex; align-items: center; flex-direction: column; margin-top:120px}
.contentno img{width: 84px; height: 68px; margin-bottom: 30px;}
.contentno .content-span{font-size: 18px; color:#ddd;}
</style>
